import React, { Component, Fragment } from "react";
import {
    Navbar,
    Container,
    Row,
    Col
} from "react-bootstrap";

import Logo from "../../assests/images/Primeluxury.png";
import { Link } from "react-router-dom";

class NavMenuDesktop extends Component {

    render() {

        return (
            <Fragment>

                <div className="TopSectionDown">

                    <Navbar
                        fixed="top"
                        className="navbar"
                        bg="light"
                    >

                        <Container
                            fluid
                            className="desktop-navbar-container fixed-top shadow-sm bg-white"
                        >

                            <Row className="w-100 align-items-center m-0">

                                {/* LOGO */}

                                <Col
                                    lg={4}
                                    md={4}
                                    className="desktop-logo-col d-flex align-items-center justify-content-start"
                                >

                                    <Link
                                        to="/"
                                        className="desktop-logo-link"
                                    >
                                        <img
                                            className="nav-logo"
                                            src={Logo}
                                            alt="Prime Luxury Passenger Transport LLC"
                                        />
                                    </Link>

                                </Col>


                                {/* CONTACT INFORMATION */}

                                <Col
                                    lg={5}
                                    md={5}
                                    className="d-flex justify-content-center align-items-center gap-3"
                                >

                                    {/* PHONE */}

                                    <a
                                        href="tel:+971501011783"
                                        className="nav-contact"
                                        title="Call Prime Luxury"
                                    >

                                        <span className="nav-contact-icon">
                                            <i className="fa fa-phone"></i>
                                        </span>

                                        <span className="nav-contact-content">

                                            <small>Call Us</small>

                                            <strong>
                                                +971 50 101 1783
                                            </strong>

                                        </span>

                                    </a>


                                    {/* EMAIL */}

                                    <a
                                        href="mailto:booking@dxblimo.com"
                                        className="nav-contact"
                                        title="Email Prime Luxury"
                                    >

                                        <span className="nav-contact-icon">
                                            <i className="fa fa-envelope"></i>
                                        </span>

                                        <span className="nav-contact-content">

                                            <small>Email Us</small>

                                            <strong>
                                                booking@dxblimo.com
                                            </strong>

                                        </span>

                                    </a>

                                </Col>


                                {/* RIGHT MENU */}

                                <Col
                                    lg={3}
                                    md={3}
                                    className="d-flex justify-content-end align-items-center"
                                >

                                    <Link
                                        to="/login"
                                        className="nav-login-button"
                                    >

                                        <i className="fa fa-user"></i>

                                        <span>
                                            LOGIN
                                        </span>

                                    </Link>

                                </Col>

                            </Row>

                        </Container>

                    </Navbar>

                </div>

            </Fragment>
        );
    }
}

export default NavMenuDesktop;